import { createFileRoute } from "@tanstack/react-router";
import { ModuleDashboard } from "@/features/dashboards/ModuleDashboard";

// Planning dashboard (PX-PLN-010): features/dashboards.
export const Route = createFileRoute("/_app/planning/dashboard")({
  component: () => <ModuleDashboard module="planning" />,
});
